var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'box',
    ("box--" + _vm.theme),
    {
      'box--with-icon': !!this.$slots['icon'],
    },
    _vm.opacity != null ? ("box--opacity-" + _vm.opacity) : '' ]},[(!this.$slots['header'] && !_vm.disableTopDecoration)?_c('div',{staticClass:"box__decorations-helper-first"}):_vm._e(),(!_vm.disableBottomDecoration)?_c('div',{staticClass:"box__decorations-helper-second"}):_vm._e(),_vm._t("icon"),_vm._t("header"),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }